import { render } from "./VideoWallEpisodeList.vue?vue&type=template&id=08768f36&ts=true"
import script from "./VideoWallEpisodeList.vue?vue&type=script&lang=ts"
export * from "./VideoWallEpisodeList.vue?vue&type=script&lang=ts"

import "./VideoWallEpisodeList.vue?vue&type=style&index=0&id=08768f36&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__